import { Component } from '@angular/core';


@Component({
  selector: 'lib-content-loader',
  templateUrl: './content-loader.component.html',
  styleUrl: './content-loader.component.scss'
})
export class LibContentLoaderComponent {

}
